import { render, staticRenderFns } from "./Dashboardtools.vue?vue&type=template&id=16220489&scoped=true&"
import script from "./Dashboardtools.vue?vue&type=script&lang=js&"
export * from "./Dashboardtools.vue?vue&type=script&lang=js&"
import style0 from "./Dashboardtools.vue?vue&type=style&index=0&id=16220489&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16220489",
  null
  
)

export default component.exports